import agent from './agent';
import config from '../config.json';
import ServiceBase from './ServiceBase';

const baseUrl = config.baseUrl2;
const service = 'batterycontrol';
const contextsUrl = `${baseUrl}/${service}/battery/contexts`;

// All endpoints plural, POST/DELETE body = { data: [dto, ...] }
class BatteryContextService extends ServiceBase {
    _config = () => ({
        headers: {
            Authorization: `Bearer ${this.getToken()}`,
            'Content-Type': 'application/json',
        },
    });

    /** @returns {Promise} all battery contexts */
    getContexts = () => agent.get(contextsUrl, this._config());

    /** @param {object[]} items - full BatteryContext DTOs, add (no rk) or update (rk) */
    postContexts = (items) => agent.post(contextsUrl, { data: items }, this._config());

    /** @param {object[]} items - full BatteryContext DTOs */
    deleteContexts = (items) => agent.delete(contextsUrl, { ...this._config(), data: { data: items } });
}

const batteryContextService = new BatteryContextService();
export default batteryContextService;
